import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import Grid from '@mui/material/Grid';

import type { ExtendedAdsQueryVariables } from '../types/extendedAdsQueryVariables';
import useGetRoomsNumberItems from 'src/hooks/useGetRoomsNumberItems';
import { PropertyTypesSelect, type PropertyTypeGroup } from 'src/components/ad/PropertyTypesSelect';
import Select from 'src/components/ui/Select';
import BudgetButton from 'src/components/news/BudgetButton';
import type { FormValues } from '../types/adSearchFormValues';

type Props = {
    searchType?: FormValues['type'];
    queryVariables?: ExtendedAdsQueryVariables;
    xs: number;
    lg?: number;
};

export const HousingRoomBudgetFilters: React.FC<Props> = ({ searchType, queryVariables, xs, lg }) => {
    const { t } = useTranslation(['ad']);
    const roomNumberItems = useGetRoomsNumberItems('rooms');

    const groupTypesToDisplay = useMemo<PropertyTypeGroup[] | undefined>(() => {
        if (searchType === 'sell') {
            return ['advertiser', 'housing', 'oldOrNew'];
        }
        return ['furnished', 'advertiser', 'housing'];
    }, [searchType]);
    return (
        <>
            <Grid xs={xs} lg={lg} item>
                <PropertyTypesSelect name="PropertyTypeSelect" groupTypesToDisplay={groupTypesToDisplay} />
            </Grid>
            <Grid xs={xs} lg={lg} item>
                <Select
                    name="rooms"
                    items={[
                        {
                            label: t('ad:rooms'),
                            value: 'default',
                        },
                        ...roomNumberItems,
                    ]}
                />
            </Grid>
            <Grid xs={xs} lg={lg} item>
                {queryVariables && <BudgetButton queryVariables={queryVariables} />}
            </Grid>
        </>
    );
};
